import { lazy, Suspense, useState } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const AIChatBubble = lazy(() => import("./AIChatBubble"));

export default function DeferredChat() {
  const [activated, setActivated] = useState(false);
  const launcher = (
    <Button aria-label="Open AI chat assistant" onClick={() => setActivated(true)} className="fixed bottom-6 left-6 z-50 bg-primary text-primary-foreground w-14 h-14 p-0 rounded-full shadow-lg">
      <MessageCircle className="w-6 h-6" />
    </Button>
  );
  return activated ? <Suspense fallback={launcher}><AIChatBubble initiallyOpen /></Suspense> : launcher;
}